import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Autocomplete, Box, Chip, TextField } from '@mui/material';
import { CancelPresentationRounded } from '@mui/icons-material';
import { PSA_ACCESS_LEVELS_RESTRICT, USER_TYPE } from '../../../utils/constants';
import ButtonComponent from '../../Button';

// eslint-disable-next-line react/prop-types
const AccessLevelsComponent = ({ title, data, onChange, options }) => {
  const [inputValue, setInputValue] = React.useState('');

  return (
        <Box sx={{ mb: 2.5 }}>
        <Typography sx={{ fontWeight: 'bold', fontSize: '15px' }} gutterBottom>
            {title}
          </Typography>
                  <Autocomplete
                      multiple
                      id={title}
                      options={options}
                      value={data}
                      onChange={onChange}
                      inputValue={inputValue}
                      onInputChange={(event, newInputValue) => {
                        setInputValue(newInputValue);
                      }}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => {
                          const { key, ...tagProps } = getTagProps({ index });
                          return (
                                  <Chip variant="outlined" label={option} key={key} {...tagProps} />
                          );
                        })
                      }
                      renderInput={(params) => (
                          <TextField
                              {...params}
                              variant="outlined"
                              label=""
                              placeholder={'Add ' + title}
                          />
                      )}
                  />
        </Box>
  );
};

const AccessLevelsDialog = ({ open, handleClose, rowData, handleSave }) => {
  const [accessLevels, setAccessLevels] = useState([]);
  const userTypes = Object.keys(USER_TYPE).filter(key => key.includes('PREMIUM') && key !== 'PREMIUM_ADMIN' && key !== 'PREMIUM_SELECT_ADMIN');
  const availableSelectOptions = filterUserTypes(accessLevels, userTypes);

  function filterUserTypes(selectedTypes, userTypes) {
    const excludedTypes = new Set(
      selectedTypes.flatMap(type => PSA_ACCESS_LEVELS_RESTRICT[type] || [])
    );
    return userTypes.filter(type => !excludedTypes.has(type) || selectedTypes.includes(type));
  }

  useEffect(() => {
    setAccessLevels(rowData?.accessLevels || []);
  }, [rowData]);

  return (
    <React.Fragment>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth='md'
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {rowData.name || rowData.firstName}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={() => ({
            position: 'absolute',
            right: 8,
            top: 8,
          })}
        >
          <CancelPresentationRounded fontSize='large'/>
        </IconButton>
        <DialogContent dividers sx={{ minWidth: '600px' }}>
            <AccessLevelsComponent
                title='Access Levels'
                data={accessLevels}
                onChange={(event, values) => setAccessLevels([...values])}
                options={availableSelectOptions}
            />
        </DialogContent>
        <DialogActions>
          <ButtonComponent
            label="Save"
            size="small"
            disabled={!accessLevels?.length}
            onClick={() => {
              const updatedData = { ...rowData };
              updatedData.accessLevels = accessLevels;
              handleSave(updatedData);
              handleClose();
            }}>
          </ButtonComponent>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

AccessLevelsDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  rowData: PropTypes.object.isRequired,
  handleSave: PropTypes.func.isRequired
};

export default AccessLevelsDialog;
